import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Capa_1",
	x: "0px",
	y: "0px",
	width: "512px",
	height: "512px",
	viewBox: "0 0 488.152 488.152",
	style: { enableBackground: "new 0 0 488.152 488.152" },
	xmlSpace: "preserve",
	className: "",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M177.854,269.311c0-6.115-4.96-11.069-11.08-11.069h-38.665c-6.113,0-11.074,4.954-11.074,11.069v38.66    c0,6.123,4.961,11.079,11.074,11.079h38.665c6.12,0,11.08-4.956,11.08-11.079V269.311L177.854,269.311z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.483,269.311c0-6.115-4.961-11.069-11.069-11.069h-38.67c-6.113,0-11.074,4.954-11.074,11.069v38.66    c0,6.123,4.961,11.079,11.074,11.079h38.67c6.108,0,11.069-4.956,11.069-11.079V269.311z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M371.117,269.311c0-6.115-4.961-11.069-11.074-11.069h-38.665c-6.12,0-11.08,4.954-11.08,11.069v38.66    c0,6.123,4.96,11.079,11.08,11.079h38.665c6.113,0,11.074-4.956,11.074-11.079V269.311z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.854,365.95c0-6.125-4.96-11.075-11.08-11.075h-38.665c-6.113,0-11.074,4.95-11.074,11.075v38.653    c0,6.119,4.961,11.074,11.074,11.074h38.665c6.12,0,11.08-4.956,11.08-11.074V365.95L177.854,365.95z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.483,365.95c0-6.125-4.961-11.075-11.069-11.075h-38.67c-6.113,0-11.074,4.95-11.074,11.075v38.653    c0,6.119,4.961,11.074,11.074,11.074h38.67c6.108,0,11.069-4.956,11.069-11.074V365.95z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M371.117,365.95c0-6.125-4.961-11.075-11.069-11.075h-38.67c-6.12,0-11.08,4.95-11.08,11.075v38.653    c0,6.119,4.96,11.074,11.08,11.074h38.67c6.108,0,11.069-4.956,11.069-11.074V365.95L371.117,365.95z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M440.254,54.354v59.05c0,26.69-21.652,48.198-48.338,48.198h-30.493c-26.688,0-48.627-21.508-48.627-48.198V54.142    h-137.44v59.262c0,26.69-21.938,48.198-48.622,48.198H96.235c-26.685,0-48.336-21.508-48.336-48.198v-59.05    C24.576,55.057,5.411,74.356,5.411,98.077v346.061c0,24.167,19.588,44.015,43.755,44.015h389.82    c24.131,0,43.755-19.889,43.755-44.015V98.077C482.741,74.356,463.577,55.057,440.254,54.354z M426.091,422.588    c0,10.444-8.468,18.917-18.916,18.917H80.144c-10.448,0-18.916-8.473-18.916-18.917V243.835c0-10.448,8.467-18.921,18.916-18.921    h327.03c10.448,0,18.916,8.473,18.916,18.921L426.091,422.588L426.091,422.588z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.128,129.945h30.162c9.155,0,16.578-7.412,16.578-16.567V16.573C142.868,7.417,135.445,0,126.29,0H96.128    C86.972,0,79.55,7.417,79.55,16.573v96.805C79.55,122.533,86.972,129.945,96.128,129.945z",
			className: "active-path",
			fill: "#2D323E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M361.035,129.945h30.162c9.149,0,16.572-7.412,16.572-16.567V16.573C407.77,7.417,400.347,0,391.197,0h-30.162    c-9.154,0-16.577,7.417-16.577,16.573v96.805C344.458,122.533,351.881,129.945,361.035,129.945z",
			className: "active-path",
			fill: "#2D323E"
		})
	] }) }) })
});
export default SvgDate;
